export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: Date;
  UUID: string;
  Upload: File;
};

export enum Action {
  Write = 'write',
  Read = 'read'
}

export type AggregatedArbitraryPlannedProgress = {
  __typename?: 'AggregatedArbitraryPlannedProgress';
  progress?: Maybe<Scalars['Float']>;
  timestamp: Scalars['Date'];
  status: ProgressStatus;
  subcontractorId?: Maybe<Scalars['UUID']>;
};

export type AggregatedArbitraryPredictedProgress = {
  __typename?: 'AggregatedArbitraryPredictedProgress';
  progress?: Maybe<Scalars['Float']>;
  batch: Batch;
  status: ProgressStatus;
  subcontractorId?: Maybe<Scalars['UUID']>;
};

export type AggregatedArbitraryProgress = {
  __typename?: 'AggregatedArbitraryProgress';
  progress?: Maybe<Scalars['Float']>;
  batch: Batch;
  status: ProgressStatus;
  subcontractorId?: Maybe<Scalars['UUID']>;
};

export type AggregatedPlannedProgress = {
  __typename?: 'AggregatedPlannedProgress';
  task?: Maybe<Task>;
  plan?: Maybe<Plan>;
  subcontractor?: Maybe<Subcontractor>;
  space?: Maybe<Space>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  timestamp: Scalars['Date'];
  progress?: Maybe<Scalars['Float']>;
  status: ProgressStatus;
};

export type AggregatedPredictedProgress = {
  __typename?: 'AggregatedPredictedProgress';
  task?: Maybe<Task>;
  plan?: Maybe<Plan>;
  subcontractor?: Maybe<Subcontractor>;
  space?: Maybe<Space>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  batch: Batch;
  progress?: Maybe<Scalars['Float']>;
  status: ProgressStatus;
};

export type AggregatedProgress = {
  __typename?: 'AggregatedProgress';
  task?: Maybe<Task>;
  component?: Maybe<Component>;
  plan?: Maybe<Plan>;
  subcontractor?: Maybe<Subcontractor>;
  space: Space;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  batch: Batch;
  progress?: Maybe<Scalars['Float']>;
  status: ProgressStatus;
};

export type AggregatedSchedule = ScheduleInterface & {
  __typename?: 'AggregatedSchedule';
  task: Task;
  space: Space;
  ranges: Array<Range>;
  aggregatedOver: Array<Space>;
};

export type AnnotationLocation = {
  __typename?: 'AnnotationLocation';
  pitch: Scalars['Float'];
  yaw: Scalars['Float'];
};

export type AnnotationLocationInputType = {
  pitch: Scalars['Float'];
  yaw: Scalars['Float'];
};

export type Arrow = {
  __typename?: 'Arrow';
  id: Scalars['UUID'];
  missing: Scalars['Boolean'];
  targetScene?: Maybe<Scene>;
  scene: Scene;
  location: AnnotationLocation;
  locationInImage: AnnotationLocation;
};

export type AuthQueryStringMapping = {
  __typename?: 'AuthQueryStringMapping';
  tileSuffix: Scalars['String'];
  queryString: Scalars['String'];
};

export type Batch = {
  __typename?: 'Batch';
  id: Scalars['UUID'];
  timestamp: Scalars['Date'];
  weekNumber: Scalars['Int'];
  shots: Array<Shot>;
};

export type BimFloorModel = {
  __typename?: 'BimFloorModel';
  label: Scalars['String'];
  bimFloorId: Scalars['String'];
  isCommon: Scalars['Boolean'];
};

export type BimFloorModelInput = {
  label: Scalars['String'];
  bimFloorId: Scalars['String'];
  isCommon: Scalars['Boolean'];
};

export type BimModel = {
  __typename?: 'BimModel';
  label: Scalars['String'];
  bimModelId: Scalars['String'];
  isCommon: Scalars['Boolean'];
};

export type BimToken = {
  __typename?: 'BimToken';
  token: Scalars['String'];
  expiresIn: Scalars['Int'];
};

export type BimUrn = {
  __typename?: 'BimUrn';
  id: Scalars['UUID'];
  title: Scalars['String'];
  urn: Scalars['String'];
};

export enum ChangeState {
  Change = 'CHANGE',
  NoChange = 'NO_CHANGE'
}

export type ClearDateInputType = {
  taskId?: Maybe<Scalars['UUID']>;
  spaceId?: Maybe<Scalars['UUID']>;
};

export type Component = {
  __typename?: 'Component';
  id: Scalars['UUID'];
  shell360Id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  guiIndex?: Maybe<Scalars['Int']>;
  componentType: ComponentType;
  subcontractor?: Maybe<Subcontractor>;
  weight?: Maybe<Scalars['Float']>;
  isMapped: Scalars['Boolean'];
  parentTask?: Maybe<Task>;
  object?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  aggregatedProgresses: Array<AggregatedProgress>;
  aggregatedPlannedProgresses: Array<AggregatedPlannedProgress>;
  actualDates: Array<Dates>;
};


export type ComponentGuiIndexArgs = {
  taskId?: Maybe<Scalars['UUID']>;
  planId?: Maybe<Scalars['UUID']>;
};


export type ComponentWeightArgs = {
  taskId?: Maybe<Scalars['UUID']>;
  planId?: Maybe<Scalars['UUID']>;
};


export type ComponentParentTaskArgs = {
  planId: Scalars['UUID'];
};


export type ComponentAggregatedProgressesArgs = {
  planId: Scalars['UUID'];
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  batchIds: Array<Scalars['UUID']>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  onlyInProgressTasks?: Maybe<Scalars['Boolean']>;
};


export type ComponentAggregatedPlannedProgressesArgs = {
  planId: Scalars['UUID'];
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  timestamps: Array<Scalars['Date']>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
};


export type ComponentActualDatesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  planId: Scalars['UUID'];
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};

export type ComponentType = {
  __typename?: 'ComponentType';
  id: Scalars['UUID'];
  name: Scalars['String'];
  description: Scalars['String'];
};

export type CreateArrowInputType = {
  sceneId: Scalars['UUID'];
  targetSceneId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  location: AnnotationLocationInputType;
};

export type CreateBulkMappingInputType = {
  componentId: Scalars['UUID'];
  spaceIds: Array<Scalars['UUID']>;
};

export type CreateComponentInputType = {
  taskId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  componentTypeId: Scalars['UUID'];
  subcontractorId?: Maybe<Scalars['UUID']>;
  weight?: Maybe<Scalars['Float']>;
  object: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type CreateFloorplanInputType = {
  spaceId: Scalars['UUID'];
  originX: Scalars['Float'];
  originY: Scalars['Float'];
  width: Scalars['Float'];
  height: Scalars['Float'];
  mmScaleFactor: Scalars['Float'];
  floorplanFile: Scalars['Upload'];
  scaleStartX?: Maybe<Scalars['Float']>;
  scaleStartY?: Maybe<Scalars['Float']>;
  scaleEndX?: Maybe<Scalars['Float']>;
  scaleEndY?: Maybe<Scalars['Float']>;
  scaleDistanceMm?: Maybe<Scalars['Float']>;
  bimOriginX?: Maybe<Scalars['Float']>;
  bimOriginY?: Maybe<Scalars['Float']>;
  bimOriginZ?: Maybe<Scalars['Float']>;
  floorHeight?: Maybe<Scalars['Float']>;
  angleToTrueNorth?: Maybe<Scalars['Float']>;
  bimProjectId?: Maybe<Scalars['String']>;
  bimFloorIds?: Maybe<Array<Scalars['String']>>;
  bimFloorModels?: Maybe<Array<BimFloorModelInput>>;
};

export type CreateJiraIssueInputType = {
  username: Scalars['String'];
  type: JiraIssueType;
  uniqueShotId: Scalars['String'];
  week: Scalars['String'];
  path: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type CreateProjectInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  displayName: Scalars['String'];
  defaultLanguage: Scalars['String'];
  openSpace?: Maybe<CreateProjectOpenSpaceInputType>;
  isGcp?: Maybe<Scalars['Boolean']>;
};

export type CreateProjectOpenSpaceInputType = {
  region: Scalars['String'];
  organizationId: Scalars['String'];
  siteId: Scalars['String'];
};

export type CreateScanSequenceInputType = {
  floorplanId: Scalars['UUID'];
  sequencePrefix: ScanSequencePrefixType;
  scanLevel: ScanSequenceLevelType;
  sceneIds: Array<Scalars['UUID']>;
};

export type CreateSceneInputType = {
  name: Scalars['String'];
  spaceId: Scalars['UUID'];
  mmX?: Maybe<Scalars['Float']>;
  mmY?: Maybe<Scalars['Float']>;
};

export type CreateSpaceInputType = {
  name: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  parentSpaceId?: Maybe<Scalars['UUID']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type CreateSpotlightInputType = {
  type: SpotlightType;
  mappingId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  sceneId: Scalars['UUID'];
  location: AnnotationLocationInputType;
  createdInBatchId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  p2Type?: Maybe<P2SpotlightType>;
  defaultPriority?: Maybe<SpotlightPriority>;
  priority?: Maybe<SpotlightPriority>;
  userCreated?: Maybe<Scalars['Boolean']>;
};

export type CreateTaskInputType = {
  name: Scalars['String'];
  planId: Scalars['UUID'];
  parentTaskId?: Maybe<Scalars['UUID']>;
};

export type Customer = {
  __typename?: 'Customer';
  customer: Scalars['String'];
  collabStarted?: Maybe<Scalars['Date']>;
  imagesCaptured?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  upcomingProjects?: Maybe<Scalars['Int']>;
};


export type Dates = {
  __typename?: 'Dates';
  task?: Maybe<Task>;
  component?: Maybe<Component>;
  plan?: Maybe<Plan>;
  space?: Maybe<Space>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type DeleteProjectInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
};

export enum DocumentType {
  DefaultDeliverable = 'defaultDeliverable',
  DeveloperDeliverable = 'developerDeliverable',
  Configuration = 'configuration',
  ProjectScope = 'projectScope'
}

export type DumpSheetSceneData = {
  __typename?: 'DumpSheetSceneData';
  sceneShell360Id: Scalars['String'];
  sceneName: Scalars['String'];
  ancestorIds: Array<Maybe<Scalars['String']>>;
  ancestorNames: Array<Scalars['String']>;
  sceneLocation: Scalars['String'];
  floorName?: Maybe<Scalars['String']>;
  scanLevel?: Maybe<ScanSequenceLevelType>;
  sequenceNumber?: Maybe<Scalars['String']>;
  sceneAliasShell360Id?: Maybe<Scalars['String']>;
};

export type ExecViewInputs = {
  __typename?: 'ExecViewInputs';
  rootSpaceId: Scalars['UUID'];
  buildingSpaceIds: Array<Scalars['UUID']>;
  batches: Array<Batch>;
  plannedBatches: Array<Batch>;
  predictedBatches: Array<Batch>;
  plan: Scalars['UUID'];
};

export type FileGroup = {
  __typename?: 'FileGroup';
  files: Array<S3File>;
  name: Scalars['String'];
};

export type FloatUpdate = {
  newValue: Scalars['Float'];
};

export type Floorplan = {
  __typename?: 'Floorplan';
  id: Scalars['UUID'];
  signedUrl: Scalars['String'];
  originX: Scalars['Float'];
  originY: Scalars['Float'];
  width: Scalars['Float'];
  height: Scalars['Float'];
  mmScaleFactor: Scalars['Float'];
  scaleStartX?: Maybe<Scalars['Float']>;
  scaleStartY?: Maybe<Scalars['Float']>;
  scaleEndX?: Maybe<Scalars['Float']>;
  scaleEndY?: Maybe<Scalars['Float']>;
  scaleDistanceMm?: Maybe<Scalars['Float']>;
  bimOriginX?: Maybe<Scalars['Float']>;
  bimOriginY?: Maybe<Scalars['Float']>;
  bimOriginZ?: Maybe<Scalars['Float']>;
  floorHeight?: Maybe<Scalars['Float']>;
  angleToTrueNorth?: Maybe<Scalars['Float']>;
  space: Space;
  bimProjectId?: Maybe<Scalars['String']>;
  bimFloorIds?: Maybe<Array<Scalars['String']>>;
  bimFloorModels?: Maybe<Array<BimFloorModel>>;
  osSheetIds: Array<Scalars['String']>;
  osSheetMappings: Array<FloorplanOsSheetMapping>;
};

export type FloorplanOsSheetMapping = {
  __typename?: 'FloorplanOsSheetMapping';
  osSheetId: Scalars['String'];
  scanLevel?: Maybe<ScanSequenceLevelType>;
  imageId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  imageId: Scalars['String'];
  state: ChangeState;
};

export type InferredSchedule = ScheduleInterface & {
  __typename?: 'InferredSchedule';
  task: Task;
  space: Space;
  ranges: Array<Range>;
  inferredFrom: Space;
};

export type JiraIssue = {
  __typename?: 'JiraIssue';
  id: Scalars['Int'];
  uniqueShotId: Scalars['String'];
  type: JiraIssueType;
  message?: Maybe<Scalars['String']>;
};

export enum JiraIssueType {
  Level = 'LEVEL',
  Arrow = 'ARROW',
  Map = 'MAP',
  FaceBlur = 'FACE_BLUR',
  ChangeDetection = 'CHANGE_DETECTION'
}

export type Mapping = {
  __typename?: 'Mapping';
  id: Scalars['UUID'];
  space: Space;
  component: Component;
  disabled: Scalars['Boolean'];
  rawProgress?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};


export type MappingRawProgressArgs = {
  batchId: Scalars['UUID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createSpotlight: Spotlight;
  updateSpotlight?: Maybe<Spotlight>;
  deleteSpotlight?: Maybe<Scalars['Boolean']>;
  createComponent: Component;
  updateComponents: Array<Component>;
  deleteComponents?: Maybe<Scalars['Boolean']>;
  removeComponentsFromTask?: Maybe<Scalars['Boolean']>;
  createPlan: Plan;
  updatePlan: Plan;
  deletePlan: Scalars['UUID'];
  createTask: Task;
  deleteTasks: Array<Scalars['UUID']>;
  copyTasksAndComponents: Scalars['Boolean'];
  calculateWeights: Scalars['Boolean'];
  calculatePlannedProgresses: Scalars['Int'];
  updateBatches: Array<Batch>;
  deleteBatch: Scalars['Boolean'];
  updateTasks: Array<Task>;
  createSpaces: Array<Space>;
  updateSpaces: Array<Space>;
  patchSpaces: Array<Space>;
  deleteSpaces: Array<Scalars['UUID']>;
  copySpatialData: Array<Space>;
  /**
   * Replicates a space subtree together with the records attached to it -
   * mappings, progress, spotlights, every floorplan in the subtree, and the
   * space-level BIM/status/comment records. Unlike copySpatialData it does not
   * copy scanning sequences, because every replicated scene is aliased to the
   * scene it was copied from and an aliased scene may not be a sequence point.
   */
  replicateSpace: Array<Space>;
  updateSpaceBims: Space;
  createScenes: Array<Scene>;
  updateScenes: Array<Scene>;
  patchScenes: Array<Scene>;
  deleteScenes: Array<Scalars['UUID']>;
  uploadProgressFile?: Maybe<Scalars['Boolean']>;
  uploadDatesFile?: Maybe<Scalars['Boolean']>;
  uploadHolidaysFile?: Maybe<Scalars['Boolean']>;
  uploadBuildingStructureFile?: Maybe<Scalars['Boolean']>;
  uploadPlansTreeFile?: Maybe<Scalars['Boolean']>;
  updateRawMappingProgresses: Scalars['Int'];
  clearDates: Scalars['Int'];
  clearComponentTags: Scalars['Int'];
  clearSpaceTags: Scalars['Int'];
  createMappings: Array<Mapping>;
  updateMappings: Array<Mapping>;
  deleteMappings: Array<Scalars['UUID']>;
  createBulkMappings: Array<Mapping>;
  releaseDataToExternal?: Maybe<Scalars['Boolean']>;
  updateInternalAggServProgresses?: Maybe<Scalars['Boolean']>;
  createJiraIssue: JiraIssue;
  deleteJiraIssue: Scalars['Boolean'];
  createArrow: Arrow;
  updateArrow: Arrow;
  updateArrowLocationInImage: Arrow;
  deleteArrow: Scalars['UUID'];
  deleteAllHolidays?: Maybe<Scalars['Boolean']>;
  zeroPointShot: Shot;
  /** @deprecated please use patchShot instead */
  zeroPointSceneWithBim: Scene;
  deleteShot?: Maybe<Scalars['Boolean']>;
  patchShot: Shot;
  createProject: Scalars['Boolean'];
  deleteProject: Scalars['Boolean'];
  updateProjectStartDate: Project;
  updateProjectEndDate: Project;
  updateProjectReceivedOn: Project;
  updateProjectDivision: Project;
  updateProjectDisplayName: Project;
  updateProjectOpenSpaceSiteMapping: Project;
  updateProjectWorkingDays: Project;
  updateCustomer: Customer;
  createSubcontractors: Array<Subcontractor>;
  updateSubcontractor: Subcontractor;
  createComponentType: ComponentType;
  shareScreenshot?: Maybe<Scalars['Boolean']>;
  refreshComponentsTaskTags?: Maybe<Scalars['Boolean']>;
  createFloorplan: Floorplan;
  patchFloorplan: Floorplan;
  deleteFloorplan: Scalars['UUID'];
  createSheetFloorplanMapping: Floorplan;
  deleteSheetFloorplanMapping: Scalars['Boolean'];
  syncOpenSpaceSheetData: SyncOpenSpaceSheetDataResult;
  createScanSequence: ScanSequence;
  updateScanSequence: ScanSequence;
  deleteScanSequence: Scalars['UUID'];
  updateIsReleasedProjectConfig: ProjectConfig;
  updateIsTrackingProjectConfig: Project;
  updateIsTicksheetProjectConfig: Project;
  updateIsCompletedProjectConfig: Project;
};


export type MutationCreateSpotlightArgs = {
  tenant: TenantInputType;
  spotlight: CreateSpotlightInputType;
};


export type MutationUpdateSpotlightArgs = {
  tenant: TenantInputType;
  spotlight: UpdateSpotlightInputType;
};


export type MutationDeleteSpotlightArgs = {
  tenant: TenantInputType;
  spotlightId: Scalars['UUID'];
};


export type MutationCreateComponentArgs = {
  tenant: TenantInputType;
  component: CreateComponentInputType;
};


export type MutationUpdateComponentsArgs = {
  tenant: TenantInputType;
  components: Array<UpdateComponentInputType>;
};


export type MutationDeleteComponentsArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
};


export type MutationRemoveComponentsFromTaskArgs = {
  tenant: TenantInputType;
  componentIds: Array<Scalars['UUID']>;
  taskId: Scalars['UUID'];
};


export type MutationCreatePlanArgs = {
  tenant: TenantInputType;
  planName: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
};


export type MutationUpdatePlanArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
  planName: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
};


export type MutationDeletePlanArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
  deleteComponents?: Maybe<Scalars['Boolean']>;
  deleteMappings?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateTaskArgs = {
  tenant: TenantInputType;
  task: CreateTaskInputType;
};


export type MutationDeleteTasksArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
};


export type MutationCopyTasksAndComponentsArgs = {
  tenant: TenantInputType;
  sourcePlanId: Scalars['UUID'];
  targetPlanId: Scalars['UUID'];
};


export type MutationCalculateWeightsArgs = {
  tenant: TenantInputType;
  spaceIds?: Maybe<Array<Scalars['UUID']>>;
  taskIds?: Maybe<Array<Scalars['UUID']>>;
  planIds?: Maybe<Array<Scalars['UUID']>>;
};


export type MutationCalculatePlannedProgressesArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
};


export type MutationUpdateBatchesArgs = {
  tenant: TenantInputType;
  batches: Array<UpdateBatchInputType>;
};


export type MutationDeleteBatchArgs = {
  tenant: TenantInputType;
  batchId: Scalars['UUID'];
};


export type MutationUpdateTasksArgs = {
  tenant: TenantInputType;
  tasks: Array<UpdateTaskInputType>;
};


export type MutationCreateSpacesArgs = {
  tenant: TenantInputType;
  spaces: Array<CreateSpaceInputType>;
};


export type MutationUpdateSpacesArgs = {
  tenant: TenantInputType;
  spaces: Array<UpdateSpaceInputType>;
};


export type MutationPatchSpacesArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  update: PatchSpaceInputType;
};


export type MutationDeleteSpacesArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
};


export type MutationCopySpatialDataArgs = {
  tenant: TenantInputType;
  existingRootSpaceId: Scalars['UUID'];
  newRootParentSpaceId: Scalars['UUID'];
  newSpaceName?: Maybe<Scalars['String']>;
  newFloorHeight?: Maybe<Scalars['Float']>;
};


export type MutationReplicateSpaceArgs = {
  tenant: TenantInputType;
  existingRootSpaceId: Scalars['UUID'];
  newRootParentSpaceId: Scalars['UUID'];
  newSpaceName?: Maybe<Scalars['String']>;
  newFloorHeight?: Maybe<Scalars['Float']>;
  options?: Maybe<ReplicateSpaceOptionsInputType>;
};


export type MutationUpdateSpaceBimsArgs = {
  tenant: TenantInputType;
  spaceId: Scalars['UUID'];
  bimModels: Array<SpaceBimModelInput>;
};


export type MutationCreateScenesArgs = {
  tenant: TenantInputType;
  scenes: Array<CreateSceneInputType>;
};


export type MutationUpdateScenesArgs = {
  tenant: TenantInputType;
  scenes: Array<UpdateSceneInputType>;
};


export type MutationPatchScenesArgs = {
  tenant: TenantInputType;
  sceneIds: Array<Scalars['UUID']>;
  update: PatchSceneInputType;
};


export type MutationDeleteScenesArgs = {
  tenant: TenantInputType;
  sceneIds: Array<Scalars['UUID']>;
};


export type MutationUploadProgressFileArgs = {
  tenant: TenantInputType;
  progressFile: Scalars['Upload'];
};


export type MutationUploadDatesFileArgs = {
  tenant: TenantInputType;
  datesFile: Scalars['Upload'];
};


export type MutationUploadHolidaysFileArgs = {
  tenant: TenantInputType;
  holidaysFile: Scalars['Upload'];
};


export type MutationUploadBuildingStructureFileArgs = {
  tenant: TenantInputType;
  buildingStructureFile: Scalars['Upload'];
  parentId?: Maybe<Scalars['UUID']>;
};


export type MutationUploadPlansTreeFileArgs = {
  tenant: TenantInputType;
  plansTreeFile: Scalars['Upload'];
  planId: Scalars['UUID'];
};


export type MutationUpdateRawMappingProgressesArgs = {
  tenant: TenantInputType;
  batchId: Scalars['UUID'];
  componentId: Scalars['UUID'];
  spaceId: Scalars['UUID'];
  progress: Scalars['Int'];
};


export type MutationClearDatesArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
  taskSpace?: Maybe<Array<ClearDateInputType>>;
};


export type MutationClearComponentTagsArgs = {
  tenant: TenantInputType;
  prefix: Scalars['String'];
};


export type MutationClearSpaceTagsArgs = {
  tenant: TenantInputType;
  prefix: Scalars['String'];
};


export type MutationCreateMappingsArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  componentIds: Array<Scalars['UUID']>;
};


export type MutationUpdateMappingsArgs = {
  tenant: TenantInputType;
  mappings: Array<UpdateMappingInputType>;
};


export type MutationDeleteMappingsArgs = {
  tenant: TenantInputType;
  mappingIds: Array<Scalars['UUID']>;
};


export type MutationCreateBulkMappingsArgs = {
  tenant: TenantInputType;
  componentSpace: Array<CreateBulkMappingInputType>;
};


export type MutationReleaseDataToExternalArgs = {
  tenant: TenantInputType;
};


export type MutationUpdateInternalAggServProgressesArgs = {
  tenant: TenantInputType;
};


export type MutationCreateJiraIssueArgs = {
  tenant: TenantInputType;
  issue: CreateJiraIssueInputType;
};


export type MutationDeleteJiraIssueArgs = {
  tenant: TenantInputType;
  issueId: Scalars['String'];
};


export type MutationCreateArrowArgs = {
  tenant: TenantInputType;
  arrow: CreateArrowInputType;
};


export type MutationUpdateArrowArgs = {
  tenant: TenantInputType;
  arrow: UpdateArrowInputType;
};


export type MutationUpdateArrowLocationInImageArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
  locationInImage: AnnotationLocationInputType;
};


export type MutationDeleteArrowArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type MutationDeleteAllHolidaysArgs = {
  tenant: TenantInputType;
};


export type MutationZeroPointShotArgs = {
  tenant: TenantInputType;
  shotId: Scalars['UUID'];
  newYaw: Scalars['Float'];
};


export type MutationZeroPointSceneWithBimArgs = {
  tenant: TenantInputType;
  sceneId: Scalars['UUID'];
  newYaw: Scalars['Float'];
};


export type MutationDeleteShotArgs = {
  tenant: TenantInputType;
  shotId: Scalars['UUID'];
};


export type MutationPatchShotArgs = {
  tenant: TenantInputType;
  shotId: Scalars['UUID'];
  patch: PatchShotInputType;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInputType;
};


export type MutationDeleteProjectArgs = {
  input: DeleteProjectInputType;
};


export type MutationUpdateProjectStartDateArgs = {
  input: UpdateStartDateInputType;
};


export type MutationUpdateProjectEndDateArgs = {
  input: UpdateEndDateInputType;
};


export type MutationUpdateProjectReceivedOnArgs = {
  input: UpdateReceivedOnInputType;
};


export type MutationUpdateProjectDivisionArgs = {
  input: UpdateProjectDivisionInputType;
};


export type MutationUpdateProjectDisplayNameArgs = {
  input: UpdateProjectDisplayNameInputType;
};


export type MutationUpdateProjectOpenSpaceSiteMappingArgs = {
  input: UpdateProjectOpenSpaceSiteMappingInputType;
};


export type MutationUpdateProjectWorkingDaysArgs = {
  input: UpdateProjectWorkingDaysInputType;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInputType;
};


export type MutationCreateSubcontractorsArgs = {
  tenant: TenantInputType;
  subcontractors: Array<Scalars['String']>;
};


export type MutationUpdateSubcontractorArgs = {
  tenant: TenantInputType;
  subcontractor: UpdateSubcontractorInputType;
};


export type MutationCreateComponentTypeArgs = {
  tenant: TenantInputType;
  name: Scalars['String'];
  description: Scalars['String'];
};


export type MutationShareScreenshotArgs = {
  tenant: TenantInputType;
  to: Array<Scalars['String']>;
  cc: Array<Scalars['String']>;
  subject: Scalars['String'];
  body: Scalars['String'];
  screenshotName: Scalars['String'];
  screenshotPayload: Scalars['String'];
};


export type MutationRefreshComponentsTaskTagsArgs = {
  tenant: TenantInputType;
};


export type MutationCreateFloorplanArgs = {
  tenant: TenantInputType;
  floorplan: CreateFloorplanInputType;
};


export type MutationPatchFloorplanArgs = {
  tenant: TenantInputType;
  floorplan: PatchFloorplanInputType;
};


export type MutationDeleteFloorplanArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type MutationCreateSheetFloorplanMappingArgs = {
  tenant: TenantInputType;
  floorplanId: Scalars['UUID'];
  osSheetId: Scalars['String'];
  scanLevel?: Maybe<ScanSequenceLevelType>;
  imageId?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
};


export type MutationDeleteSheetFloorplanMappingArgs = {
  tenant: TenantInputType;
  floorplanId: Scalars['UUID'];
  osSheetId: Scalars['String'];
};


export type MutationCreateScanSequenceArgs = {
  tenant: TenantInputType;
  scanSequence: CreateScanSequenceInputType;
};


export type MutationUpdateScanSequenceArgs = {
  tenant: TenantInputType;
  scanSequence: UpdateScanSequenceInputType;
};


export type MutationDeleteScanSequenceArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type MutationUpdateIsReleasedProjectConfigArgs = {
  input: UpdateIsReleasedProjectConfigInput;
};


export type MutationUpdateIsTrackingProjectConfigArgs = {
  input: UpdateIsTrackingProjectConfigInput;
};


export type MutationUpdateIsTicksheetProjectConfigArgs = {
  input: UpdateIsTicksheetProjectConfigInput;
};


export type MutationUpdateIsCompletedProjectConfigArgs = {
  input: UpdateIsCompletedProjectConfigInput;
};

export type NullableFloatUpdate = {
  newValue?: Maybe<Scalars['Float']>;
};

export type NullableStringUpdate = {
  newValue?: Maybe<Scalars['String']>;
};

export type NullableUuidUpdate = {
  newValue?: Maybe<Scalars['UUID']>;
};

export enum P2SpotlightType {
  PotentialRework = 'PotentialRework',
  PotentialDelay = 'PotentialDelay',
  ReworkNeeded = 'ReworkNeeded',
  ReworkInProgress = 'ReworkInProgress',
  NonConformance = 'NonConformance',
  HealthAndSafety = 'HealthAndSafety',
  Unknown = 'Unknown'
}

export type PvaSpaceInput = {
  mappings: Array<SubcontractorSpaceMapping>;
};

export type PvaSubcontractorProgress = {
  __typename?: 'PVASubcontractorProgress';
  spaceId: Scalars['UUID'];
  subcontractorId: Scalars['UUID'];
  actualProgress?: Maybe<Scalars['Float']>;
  plannedProgress?: Maybe<Scalars['Float']>;
  batchIds: Scalars['UUID'];
  batchTimestamps: Scalars['Date'];
};

export type PvaTaskProgress = {
  __typename?: 'PVATaskProgress';
  activityIds: Array<Scalars['UUID']>;
  spaceId: Scalars['UUID'];
  subcontractorId: Scalars['UUID'];
  aggregatedProgress: Array<SubcontractorBatchProgress>;
};

export type PanoramaConfig = {
  __typename?: 'PanoramaConfig';
  imageId: Scalars['String'];
  initialHfov: Scalars['Float'];
  initialYaw: Scalars['Float'];
  initialPitch: Scalars['Float'];
  basePath: Scalars['String'];
  pathTemplate: Scalars['String'];
  cubeResolution: Scalars['Int'];
  tileResolution: Scalars['Int'];
  maxLevel: Scalars['Int'];
  extension: Scalars['String'];
  authQueryStrings: Array<AuthQueryStringMapping>;
  uniqueImageId?: Maybe<Scalars['String']>;
};

export type ParsingMapping = {
  __typename?: 'ParsingMapping';
  id: Scalars['UUID'];
  ancestorNames: Array<Scalars['String']>;
  disabled: Scalars['Boolean'];
};

export type PatchFloorplanInputType = {
  id: Scalars['UUID'];
  setSpaceId?: Maybe<Scalars['UUID']>;
  setOriginX?: Maybe<Scalars['Float']>;
  setOriginY?: Maybe<Scalars['Float']>;
  setWidth?: Maybe<Scalars['Float']>;
  setHeight?: Maybe<Scalars['Float']>;
  setMMScaleFactor?: Maybe<Scalars['Float']>;
  setFloorplanFile?: Maybe<Scalars['Upload']>;
  setScaleStartX?: Maybe<Scalars['Float']>;
  setScaleStartY?: Maybe<Scalars['Float']>;
  setScaleEndX?: Maybe<Scalars['Float']>;
  setScaleEndY?: Maybe<Scalars['Float']>;
  setScaleDistanceMm?: Maybe<Scalars['Float']>;
  setBimOriginX?: Maybe<Scalars['Float']>;
  setBimOriginY?: Maybe<Scalars['Float']>;
  setBimOriginZ?: Maybe<Scalars['Float']>;
  setFloorHeight?: Maybe<Scalars['Float']>;
  setAngleToTrueNorth?: Maybe<Scalars['Float']>;
  setBimProjectId?: Maybe<Scalars['String']>;
  setBimFloorIds?: Maybe<Array<Scalars['String']>>;
  setBimFloorModels?: Maybe<Array<BimFloorModelInput>>;
};

export type PatchSceneInputType = {
  setName?: Maybe<StringUpdate>;
  setSpaceId?: Maybe<UuidUpdate>;
  setMMX?: Maybe<NullableFloatUpdate>;
  setMMY?: Maybe<NullableFloatUpdate>;
  setMMZOffset?: Maybe<FloatUpdate>;
  setAliasSceneId?: Maybe<NullableUuidUpdate>;
  addSubjects?: Maybe<Array<SceneSubject>>;
  removeSubjects?: Maybe<Array<SceneSubject>>;
};

export type PatchShotInputType = {
  setYaw?: Maybe<FloatUpdate>;
  setImageId?: Maybe<NullableStringUpdate>;
};

export type PatchSpaceInputType = {
  setName?: Maybe<StringUpdate>;
  setCategory?: Maybe<StringUpdate>;
  setType?: Maybe<StringUpdate>;
  addTags?: Maybe<Array<Scalars['String']>>;
  removeTags?: Maybe<Array<Scalars['String']>>;
  setParentId?: Maybe<NullableUuidUpdate>;
};

export type PdfSpotlight = {
  __typename?: 'PdfSpotlight';
  spotlightId: Scalars['UUID'];
  sceneId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  shotId: Scalars['UUID'];
  yaw: Scalars['Float'];
  imageId?: Maybe<Scalars['String']>;
};

export type Permission = {
  action: Action;
  resource: Scalars['String'];
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['UUID'];
  shell360Id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  tasks: Array<Task>;
  components: Array<Component>;
  aggregatedProgresses: Array<AggregatedProgress>;
  aggregatedPlannedProgresses: Array<AggregatedPlannedProgress>;
  aggregatedPredictedProgresses: Array<AggregatedPredictedProgress>;
  actualDates: Array<Dates>;
  shotsCount: Array<PlanShotsCountBySpace>;
};


export type PlanTasksArgs = {
  rootTasksOnly?: Scalars['Boolean'];
};


export type PlanAggregatedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  batchIds: Array<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  onlyInProgressTasks?: Maybe<Scalars['Boolean']>;
};


export type PlanAggregatedPlannedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  timestamps: Array<Scalars['Date']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
};


export type PlanAggregatedPredictedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  batchIds: Array<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
};


export type PlanActualDatesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};


export type PlanShotsCountArgs = {
  spaceIds: Array<Scalars['UUID']>;
  batchIds?: Maybe<Array<Scalars['UUID']>>;
};

export type PlanShotsCountBySpace = {
  __typename?: 'PlanShotsCountBySpace';
  spaceId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  totalSceneShots: Scalars['Int'];
  dummyShots: Scalars['Int'];
};

export type PlannedBatch = {
  __typename?: 'PlannedBatch';
  id: Scalars['UUID'];
  timestamp: Scalars['Date'];
  weekNumber: Scalars['Int'];
};

export type ProgressFilter = {
  taskId: Scalars['UUID'];
  spaceId: Scalars['UUID'];
  batchId: Scalars['UUID'];
};

export type ProgressParsingFilter = {
  depth: Scalars['Int'];
  name: Scalars['String'];
};

export enum ProgressStatus {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS',
  Finished = 'FINISHED'
}

export type Project = {
  __typename?: 'Project';
  customer: Scalars['String'];
  project: Scalars['String'];
  scopes: Array<Scope>;
  config: ProjectConfig;
};

export type ProjectConfig = {
  __typename?: 'ProjectConfig';
  displayName?: Maybe<Scalars['String']>;
  defaultLanguage: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  isReleased?: Maybe<Scalars['Boolean']>;
  isTracking?: Maybe<Scalars['Boolean']>;
  isTicksheetProject?: Maybe<Scalars['Boolean']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  division?: Maybe<Scalars['String']>;
  receivedOn?: Maybe<Scalars['Date']>;
  customerName?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  /** @deprecated Use sites instead, which supports multiple site IDs */
  site?: Maybe<Scalars['String']>;
  sites?: Maybe<Array<Scalars['String']>>;
  region?: Maybe<Scalars['String']>;
  isGcp?: Maybe<Scalars['Boolean']>;
  workingDays?: Maybe<Array<Scalars['Int']>>;
};

export type Query = {
  __typename?: 'Query';
  aggservSyncDate?: Maybe<Scalars['Date']>;
  batches: Array<Batch>;
  bimToken: BimToken;
  bimUrns?: Maybe<Array<BimUrn>>;
  components: Array<Component>;
  componentsByIds: Array<Component>;
  component: Component;
  componentsExcludingPlan: Array<Component>;
  componentTypes: Array<ComponentType>;
  objectTypes: Array<Scalars['String']>;
  componentTagTypes: Array<Scalars['String']>;
  componentTagTypesByPlan: Array<Scalars['String']>;
  /**
   * Get floorplans passing an optional list of floorplan ids.
   * If ids are not provided all floorplans will be returned.
   */
  floorplans: Array<Floorplan>;
  mappedFloorplans: Array<Floorplan>;
  plans: Array<Plan>;
  plan: Plan;
  shotsCount: Array<PlanShotsCountBySpace>;
  tasksByParentPlan: Array<Task>;
  task: Task;
  tasksByIds: Array<Task>;
  space: Space;
  scene?: Maybe<Scene>;
  scenesByIds: Array<Scene>;
  projects: Array<Project>;
  getProjectsByCustomer: Array<Project>;
  projectsForPermissions: Array<Project>;
  customers: Array<Customer>;
  jiraIssueForShotAndIssueType: JiraIssue;
  jiraIssuesForShot: Array<JiraIssue>;
  /**
   * Get the list of scenes that specify the order they meant to be captured
   * by the site scanner (ScanSequence) based on a set of Filters
   */
  scanSequencesByFilter: Array<ScanSequence>;
  spacesByFilter: Array<Space>;
  searchSpaces: Array<Space>;
  spacesByIds: Array<Space>;
  subcontractor: Subcontractor;
  subcontractors: Array<Subcontractor>;
  shot?: Maybe<Shot>;
  shotsForPdfCreation?: Maybe<Array<PdfSpotlight>>;
  /** @deprecated this will go soon, use the spotlightsByIds */
  spotlight: Spotlight;
  spotlightsByIds: Array<Spotlight>;
  spotlightsByFilter: Array<Spotlight>;
  spotlightHistoryBySpotlightIds: Array<SpotlightHistoryBySpotlightId>;
  mappingsForParse: Array<ParsingMapping>;
  spaceCategories: Array<Scalars['String']>;
  spaceTypes: Array<Scalars['String']>;
  spaceTags: Array<Scalars['String']>;
  generateDatesQAData: Array<RawSchedule>;
  generateDumpSheetData: Array<DumpSheetSceneData>;
  arbitraryAggregation: Array<AggregatedArbitraryProgress>;
  arbitraryPlannedAggregation: Array<AggregatedArbitraryPlannedProgress>;
  /**
   * Calculate arbitrary progress aggregations for a plan across multiple space groupings.
   * Results are returned in the same order as spaceGroupings input.
   * Only one batch is allowed per request.
   * Makes a single call to the aggregation service for all space groupings.
   */
  arbitraryAggregationBySpaceGroups: Array<AggregatedArbitraryProgress>;
  /**
   * Calculate arbitrary planned progress aggregations for a plan across multiple space groupings.
   * Results are returned in the same order as spaceGroupings input.
   * Only one timestamp is allowed per request.
   * Makes a single call to the aggregation service for all space groupings.
   */
  arbitraryPlannedAggregationBySpaceGroups: Array<AggregatedArbitraryPlannedProgress>;
  arbitraryPredictedAggregation: Array<AggregatedArbitraryPredictedProgress>;
  holidays: Array<Scalars['Date']>;
  releaseHistory: Array<ReleaseLog>;
  documents: Array<FileGroup>;
  documentByPath: FileGroup;
  canEditJiraIssues?: Maybe<Scalars['Boolean']>;
  canDeleteBatches: Scalars['Boolean'];
  earliestTimestampOnWorkQueue?: Maybe<Scalars['Date']>;
  shotByBatchAvailability?: Maybe<Array<ShotByBatchResult>>;
  getSequenceDetails: Array<SequenceDetail>;
  plannedBatches?: Maybe<Array<PlannedBatch>>;
  pvaTasksProgressBySpace: Array<PvaTaskProgress>;
  pvaSubcontractorProgressBySpace: Array<PvaSubcontractorProgress>;
  mappingsBySpaceIds: Array<Mapping>;
  mappingsForPlan: Array<Mapping>;
  execViewInputs?: Maybe<ExecViewInputs>;
  subcontractorPlannedDates: Array<SubcontractorPlannedDates>;
  subcontractorPlannedDatesInSpaces: Array<SubcontractorPlannedDatesInSpaces>;
  tasksBySpaceAndSubcontractor: Array<TaskSchedule>;
  tasksInSpaces: Array<TaskScheduleInSpaces>;
  sitePlanViewSpaces: Array<SitePlanViewSpace>;
  sitePlanViewDepth: Scalars['Int'];
};


export type QueryAggservSyncDateArgs = {
  tenant: TenantInputType;
};


export type QueryBatchesArgs = {
  tenant: TenantInputType;
  ids?: Maybe<Array<Scalars['UUID']>>;
};


export type QueryBimTokenArgs = {
  tenant: TenantInputType;
};


export type QueryBimUrnsArgs = {
  tenant: TenantInputType;
};


export type QueryComponentsArgs = {
  tenant: TenantInputType;
  taskId?: Maybe<Scalars['UUID']>;
  planId?: Maybe<Scalars['UUID']>;
};


export type QueryComponentsByIdsArgs = {
  tenant: TenantInputType;
  componentIds: Array<Scalars['UUID']>;
};


export type QueryComponentArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QueryComponentsExcludingPlanArgs = {
  tenant: TenantInputType;
  planIdToExclude: Scalars['UUID'];
};


export type QueryComponentTypesArgs = {
  tenant: TenantInputType;
};


export type QueryObjectTypesArgs = {
  tenant: TenantInputType;
};


export type QueryComponentTagTypesArgs = {
  tenant: TenantInputType;
};


export type QueryComponentTagTypesByPlanArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
};


export type QueryFloorplansArgs = {
  tenant: TenantInputType;
  ids?: Maybe<Array<Scalars['UUID']>>;
};


export type QueryMappedFloorplansArgs = {
  tenant: TenantInputType;
};


export type QueryPlansArgs = {
  tenant: TenantInputType;
};


export type QueryPlanArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QueryShotsCountArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  batchIds: Array<Scalars['UUID']>;
};


export type QueryTasksByParentPlanArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
};


export type QueryTaskArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QueryTasksByIdsArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
};


export type QuerySpaceArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QuerySceneArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QueryScenesByIdsArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
};


export type QueryProjectsArgs = {
  customer?: Maybe<Scalars['String']>;
  project?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
};


export type QueryGetProjectsByCustomerArgs = {
  tenant: TenantInputType;
};


export type QueryProjectsForPermissionsArgs = {
  templatedPermissions: Array<Permission>;
};


export type QueryCustomersArgs = {
  customer?: Maybe<Scalars['String']>;
};


export type QueryJiraIssueForShotAndIssueTypeArgs = {
  tenant: TenantInputType;
  uniqueShotId: Scalars['String'];
  issueType: JiraIssueType;
};


export type QueryJiraIssuesForShotArgs = {
  tenant: TenantInputType;
  uniqueShotId: Scalars['String'];
};


export type QueryScanSequencesByFilterArgs = {
  tenant: TenantInputType;
  scanSequenceFilters: ScanSequenceFilters;
};


export type QuerySpacesByFilterArgs = {
  tenant: TenantInputType;
  spaceFilters: SpaceFilters;
};


export type QuerySearchSpacesArgs = {
  tenant: TenantInputType;
  searchTerms: Array<Scalars['String']>;
  categories: Array<Scalars['String']>;
  types: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
  includeAncestors?: Maybe<Scalars['Boolean']>;
};


export type QuerySpacesByIdsArgs = {
  tenant: TenantInputType;
  ids?: Maybe<Array<Scalars['UUID']>>;
  shell360Ids?: Maybe<Array<Scalars['String']>>;
};


export type QuerySubcontractorArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
};


export type QuerySubcontractorsArgs = {
  tenant: TenantInputType;
};


export type QueryShotArgs = {
  tenant: TenantInputType;
  id?: Maybe<Scalars['UUID']>;
  sceneId?: Maybe<Scalars['UUID']>;
  batchId?: Maybe<Scalars['UUID']>;
};


export type QueryShotsForPdfCreationArgs = {
  tenant: TenantInputType;
  sceneBatchSpotlightIds: Array<SceneBatchSpotlightIds>;
};


export type QuerySpotlightArgs = {
  tenant: TenantInputType;
  id: Scalars['UUID'];
  batchId?: Maybe<Scalars['UUID']>;
};


export type QuerySpotlightsByIdsArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
  batchId?: Maybe<Scalars['UUID']>;
};


export type QuerySpotlightsByFilterArgs = {
  tenant: TenantInputType;
  spotlightFilters: SpotlightFilters;
};


export type QuerySpotlightHistoryBySpotlightIdsArgs = {
  tenant: TenantInputType;
  ids: Array<Scalars['UUID']>;
};


export type QueryMappingsForParseArgs = {
  tenant: TenantInputType;
  componentIds: Array<Scalars['UUID']>;
  parsingFilters: Array<ProgressParsingFilter>;
};


export type QuerySpaceCategoriesArgs = {
  tenant: TenantInputType;
};


export type QuerySpaceTypesArgs = {
  tenant: TenantInputType;
};


export type QuerySpaceTagsArgs = {
  tenant: TenantInputType;
};


export type QueryGenerateDatesQaDataArgs = {
  tenant: TenantInputType;
};


export type QueryGenerateDumpSheetDataArgs = {
  tenant: TenantInputType;
};


export type QueryArbitraryAggregationArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  componentIds?: Maybe<Array<Scalars['UUID']>>;
  taskIds?: Maybe<Array<Scalars['UUID']>>;
  planId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  batchIds: Array<Scalars['UUID']>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  forPva?: Maybe<Scalars['Boolean']>;
};


export type QueryArbitraryPlannedAggregationArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  componentIds?: Maybe<Array<Scalars['UUID']>>;
  taskIds?: Maybe<Array<Scalars['UUID']>>;
  planId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  timestamps: Array<Scalars['Date']>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  forPva?: Maybe<Scalars['Boolean']>;
};


export type QueryArbitraryAggregationBySpaceGroupsArgs = {
  tenant: TenantInputType;
  spaceGroupings: Array<Array<Scalars['UUID']>>;
  planId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};


export type QueryArbitraryPlannedAggregationBySpaceGroupsArgs = {
  tenant: TenantInputType;
  spaceGroupings: Array<Array<Scalars['UUID']>>;
  planId: Scalars['UUID'];
  timestamp: Scalars['Date'];
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};


export type QueryArbitraryPredictedAggregationArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  componentIds?: Maybe<Array<Scalars['UUID']>>;
  taskIds?: Maybe<Array<Scalars['UUID']>>;
  planId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  batchIds: Array<Scalars['UUID']>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  forPva?: Maybe<Scalars['Boolean']>;
};


export type QueryHolidaysArgs = {
  tenant: TenantInputType;
};


export type QueryReleaseHistoryArgs = {
  tenant: TenantInputType;
  mostRecent?: Maybe<Scalars['Int']>;
};


export type QueryDocumentsArgs = {
  tenant: TenantInputType;
  type: DocumentType;
};


export type QueryDocumentByPathArgs = {
  tenant: TenantInputType;
  path: Scalars['String'];
};


export type QueryCanEditJiraIssuesArgs = {
  tenant: TenantInputType;
};


export type QueryEarliestTimestampOnWorkQueueArgs = {
  tenant: TenantInputType;
};


export type QueryShotByBatchAvailabilityArgs = {
  tenant: TenantInputType;
  sceneId: Scalars['UUID'];
};


export type QueryGetSequenceDetailsArgs = {
  tenant: TenantInputType;
  floorPlanId: Scalars['String'];
  scanLevel?: Maybe<ScanSequenceLevelType>;
};


export type QueryPlannedBatchesArgs = {
  tenant: TenantInputType;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPvaTasksProgressBySpaceArgs = {
  tenant: TenantInputType;
  activityIds: Array<Scalars['UUID']>;
  spaceIds: Array<Scalars['UUID']>;
  timestamps: Array<Scalars['Date']>;
  subcontractorId: Scalars['UUID'];
  batchIds: Array<Scalars['UUID']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
};


export type QueryPvaSubcontractorProgressBySpaceArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
  batchIds: Array<Scalars['UUID']>;
  batchTimestamps: Array<Scalars['Date']>;
  subcontractorSpaceMappings: PvaSpaceInput;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};


export type QueryMappingsBySpaceIdsArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  planId?: Maybe<Scalars['UUID']>;
};


export type QueryMappingsForPlanArgs = {
  tenant: TenantInputType;
  planId: Scalars['UUID'];
};


export type QueryExecViewInputsArgs = {
  tenant: TenantInputType;
};


export type QuerySubcontractorPlannedDatesArgs = {
  tenant: TenantInputType;
  spaceAndSubcontractorPairs: Array<SubcontractorPlannedDatesInput>;
};


export type QuerySubcontractorPlannedDatesInSpacesArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  planId?: Maybe<Scalars['UUID']>;
};


export type QueryTasksBySpaceAndSubcontractorArgs = {
  tenant: TenantInputType;
  spaceAndSubcontractorPairs: Array<SubcontractorPlannedDatesInput>;
};


export type QueryTasksInSpacesArgs = {
  tenant: TenantInputType;
  spaceIds: Array<Scalars['UUID']>;
  subcontractorIds: Array<Scalars['UUID']>;
};


export type QuerySitePlanViewSpacesArgs = {
  tenant: TenantInputType;
};


export type QuerySitePlanViewDepthArgs = {
  tenant: TenantInputType;
};

export type Range = {
  __typename?: 'Range';
  weight: Scalars['Float'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type RawSchedule = {
  __typename?: 'RawSchedule';
  taskId: Scalars['UUID'];
  spaceId: Scalars['UUID'];
  weight: Scalars['Float'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type ReleaseLog = {
  __typename?: 'ReleaseLog';
  timestamp: Scalars['Date'];
  username: Scalars['String'];
};

export type ReplicateSpaceOptionsInputType = {
  /**
   * Point every replicated scene at the scene it was copied from, so shell360
   * serves the source's panorama at the new locations until the replica is
   * scanned. Chains are flattened: if the source is itself an alias, the replica
   * points at the same ultimate target.
   */
  aliasScenesToSource?: Maybe<Scalars['Boolean']>;
  /** Duplicate the space-component mappings, re-linking the same components. */
  copyMappings?: Maybe<Scalars['Boolean']>;
  /**
   * Carry over recorded progress, weights, schedules and mapping tags. The
   * replica will report the same completion as the source, so aggregated progress
   * above it counts that work twice until it is corrected.
   */
  copyProgress?: Maybe<Scalars['Boolean']>;
  /**
   * Duplicate spotlights onto the replicated scenes and mappings. Off by default:
   * duplicated spotlights inflate issue counts and reports.
   */
  copySpotlights?: Maybe<Scalars['Boolean']>;
  /** Copy floorplans found below the selected space, not just its own. */
  copyDescendantFloorplans?: Maybe<Scalars['Boolean']>;
  /** Copy space BIM models, work statuses and component comments. */
  copySpaceRecords?: Maybe<Scalars['Boolean']>;
};

export type S3File = {
  __typename?: 'S3File';
  name: Scalars['String'];
  /** @deprecated this will go soon, use the signedUrlInstead */
  key: Scalars['String'];
  /** @deprecated this will go soon, use the signedUrlInstead */
  shell360Path: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type ScanSequence = {
  __typename?: 'ScanSequence';
  id: Scalars['UUID'];
  floorplan: Floorplan;
  sequencePrefix: ScanSequencePrefixType;
  scanLevel: ScanSequenceLevelType;
  scenes: Array<Scene>;
};

export type ScanSequenceFilters = {
  floorplanIds?: Maybe<Array<Scalars['UUID']>>;
  floorplanId?: Maybe<Scalars['UUID']>;
  scanLevel?: Maybe<ScanSequenceLevelType>;
};

export enum ScanSequenceLevelType {
  Early = 'EARLY',
  Mid = 'MID',
  Late = 'LATE'
}

export enum ScanSequencePrefixType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T',
  U = 'U',
  V = 'V',
  W = 'W',
  X = 'X',
  Y = 'Y',
  Z = 'Z'
}

export type Scene = {
  __typename?: 'Scene';
  id: Scalars['UUID'];
  shell360Id: Scalars['String'];
  name: Scalars['String'];
  guiIndex: Scalars['Int'];
  space: Space;
  path: Array<Scalars['String']>;
  shots: Array<Shot>;
  shot?: Maybe<Shot>;
  previousShot?: Maybe<Shot>;
  spotlights: Array<Spotlight>;
  nextScene?: Maybe<Scene>;
  previousScene?: Maybe<Scene>;
  nextIdenticalScene?: Maybe<Scene>;
  previousIdenticalScene?: Maybe<Scene>;
  aliasScene?: Maybe<Scene>;
  subjects: Array<SceneSubject>;
  mmX?: Maybe<Scalars['Float']>;
  mmY?: Maybe<Scalars['Float']>;
  mmZOffset: Scalars['Float'];
  bimDiff?: Maybe<Scalars['Float']>;
};


export type SceneShotArgs = {
  batchId: Scalars['UUID'];
};


export type ScenePreviousShotArgs = {
  batchId: Scalars['UUID'];
};


export type SceneSpotlightsArgs = {
  batchId: Scalars['UUID'];
};


export type SceneNextSceneArgs = {
  batchId?: Maybe<Scalars['UUID']>;
  subTreeRootId?: Maybe<Scalars['UUID']>;
};


export type ScenePreviousSceneArgs = {
  batchId?: Maybe<Scalars['UUID']>;
  subTreeRootId?: Maybe<Scalars['UUID']>;
};


export type SceneNextIdenticalSceneArgs = {
  batchId?: Maybe<Scalars['UUID']>;
  subTree: Scalars['UUID'];
};


export type ScenePreviousIdenticalSceneArgs = {
  batchId?: Maybe<Scalars['UUID']>;
  subTree: Scalars['UUID'];
};

export enum SceneSubject {
  Firestop = 'FIRESTOP',
  Riser = 'RISER',
  Facade = 'FACADE',
  HighCeiling = 'HIGH_CEILING',
  BuildingFullHeight = 'BUILDING_FULL_HEIGHT'
}

export type Schedule = ScheduleInterface & {
  __typename?: 'Schedule';
  task: Task;
  space: Space;
  ranges: Array<Range>;
};

export type ScheduleInterface = {
  task: Task;
  space: Space;
  ranges: Array<Range>;
};

export enum Scope {
  Internal = 'internal',
  External = 'external'
}

export type SequenceDetail = {
  __typename?: 'SequenceDetail';
  x_mm: Scalars['Float'];
  y_mm: Scalars['Float'];
  sequencenumber: Scalars['String'];
  sceneId?: Maybe<Scalars['String']>;
};

export type Shot = {
  __typename?: 'Shot';
  id: Scalars['UUID'];
  shell360Id: Scalars['String'];
  imageId?: Maybe<Scalars['String']>;
  /** @deprecated use batch instead */
  batchId: Scalars['UUID'];
  batch: Batch;
  missing: Scalars['Boolean'];
  imageConfig: PanoramaConfig;
  yaw: Scalars['Float'];
  arrows: Array<Arrow>;
  spotlights: Array<Spotlight>;
  scene?: Maybe<Scene>;
};

export type ShotByBatchResult = {
  __typename?: 'ShotByBatchResult';
  batchId: Scalars['String'];
  sceneId: Scalars['String'];
  available: Scalars['Boolean'];
};

export type SitePlanViewSpace = {
  __typename?: 'SitePlanViewSpace';
  groupName: Scalars['String'];
  spaceIds: Array<Scalars['UUID']>;
  levelTag?: Maybe<Scalars['String']>;
  guiIndex?: Maybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
  childSpaces: Array<Scalars['UUID']>;
  phaseName?: Maybe<Scalars['String']>;
};

export type Space = {
  __typename?: 'Space';
  id: Scalars['UUID'];
  guiIndex: Scalars['Int'];
  guiIndexPath: Array<Scalars['Int']>;
  name: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  shell360Id?: Maybe<Scalars['String']>;
  parentSpace?: Maybe<Space>;
  ancestors: Array<Space>;
  siblingSpaces: Array<Space>;
  subSpaces: Array<Space>;
  descendantSpaces: Array<Space>;
  hasImages: Scalars['Boolean'];
  scenes: Array<Scene>;
  defaultScene?: Maybe<Scene>;
  mappings: Array<Mapping>;
  componentsUnderSpace: Array<Component>;
  schedules: Array<ScheduleInterface>;
  tasksUnderSpace: Array<Task>;
  bimModels: Array<BimModel>;
};


export type SpaceGuiIndexPathArgs = {
  includeSelf?: Scalars['Boolean'];
};


export type SpaceAncestorsArgs = {
  includeSelf?: Scalars['Boolean'];
  tags?: Maybe<Array<Scalars['String']>>;
};


export type SpaceSiblingSpacesArgs = {
  includeSelf?: Scalars['Boolean'];
};


export type SpaceDescendantSpacesArgs = {
  depth?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Scalars['String']>>;
};


export type SpaceHasImagesArgs = {
  batchId: Scalars['UUID'];
};


export type SpaceDefaultSceneArgs = {
  batchId?: Maybe<Scalars['UUID']>;
};


export type SpaceMappingsArgs = {
  planId?: Maybe<Scalars['UUID']>;
};


export type SpaceComponentsUnderSpaceArgs = {
  planId?: Maybe<Scalars['UUID']>;
};


export type SpaceSchedulesArgs = {
  planId: Scalars['UUID'];
};

export type SpaceBimModelInput = {
  label: Scalars['String'];
  bimModelId: Scalars['String'];
  isCommon: Scalars['Boolean'];
};

export type SpaceFilters = {
  id?: Maybe<Array<Scalars['UUID']>>;
  parentSpaceId?: Maybe<Scalars['UUID']>;
  ancestorSpaceId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['UUID']>;
  subSpaceIds?: Maybe<Array<Scalars['UUID']>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type Spotlight = {
  __typename?: 'Spotlight';
  id: Scalars['UUID'];
  type: SpotlightType;
  mapping?: Maybe<Mapping>;
  subcontractor?: Maybe<Subcontractor>;
  location: AnnotationLocation;
  scene?: Maybe<Scene>;
  userCreated: Scalars['Boolean'];
  createdInBatch: Batch;
  resolvedInBatch?: Maybe<Batch>;
  description?: Maybe<Scalars['String']>;
  p2Type: P2SpotlightType;
  defaultPriority: SpotlightPriority;
  comment?: Maybe<Scalars['String']>;
  commentAuthor?: Maybe<Scalars['String']>;
  status: SpotlightStatus;
  priority: SpotlightPriority;
  sequenceNumber?: Maybe<Scalars['Int']>;
};


export type SpotlightLocationArgs = {
  batchId?: Maybe<Scalars['UUID']>;
};

export type SpotlightFilters = {
  batchId?: Maybe<Scalars['UUID']>;
  batchIds?: Maybe<Array<Scalars['UUID']>>;
  spaceIds?: Maybe<Array<Scalars['UUID']>>;
  sceneIds?: Maybe<Array<Scalars['UUID']>>;
  workIds?: Maybe<Array<Scalars['UUID']>>;
  types?: Maybe<Array<SpotlightType>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  subcontractors?: Maybe<Array<Scalars['UUID']>>;
  p2Types?: Maybe<Array<P2SpotlightType>>;
  priorities?: Maybe<Array<SpotlightPriority>>;
  statuses?: Maybe<Array<SpotlightStatus>>;
  sequenceNumber?: Maybe<Scalars['Int']>;
};

export type SpotlightHistory = {
  __typename?: 'SpotlightHistory';
  author: Scalars['String'];
  timestamp: Scalars['Date'];
  body: SpotlightHistoryBody;
};

export type SpotlightHistoryBody = {
  __typename?: 'SpotlightHistoryBody';
  id: Scalars['UUID'];
  mappingId?: Maybe<Scalars['UUID']>;
  sceneId?: Maybe<Scalars['UUID']>;
  published?: Maybe<Scalars['Boolean']>;
  userCreated?: Maybe<Scalars['Boolean']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  type?: Maybe<SpotlightType>;
  location?: Maybe<AnnotationLocation>;
  batchId?: Maybe<Scalars['UUID']>;
  createdInBatchId?: Maybe<Scalars['UUID']>;
  resolvedInBatchId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  p2Type?: Maybe<P2SpotlightType>;
  defaultPriority?: Maybe<SpotlightPriority>;
  comment?: Maybe<Scalars['String']>;
  commentAuthor?: Maybe<Scalars['String']>;
  status?: Maybe<SpotlightStatus>;
  priority?: Maybe<SpotlightPriority>;
};

export type SpotlightHistoryBySpotlightId = {
  __typename?: 'SpotlightHistoryBySpotlightId';
  spotlightId: Scalars['UUID'];
  history: Array<SpotlightHistory>;
};

export enum SpotlightPriority {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export enum SpotlightStatus {
  Open = 'OPEN',
  ActionList = 'ACTION_LIST',
  Resolved = 'RESOLVED',
  Incorrect = 'INCORRECT'
}

export enum SpotlightType {
  MakeGood = 'MAKE_GOOD',
  NotCompleteAndSoonInaccessible = 'NOT_COMPLETE_AND_SOON_INACCESSIBLE',
  LocationMismatch = 'LOCATION_MISMATCH',
  PartiallyIncomplete = 'PARTIALLY_INCOMPLETE',
  PartiallyRemoved = 'PARTIALLY_REMOVED',
  SequenceMismatch = 'SEQUENCE_MISMATCH',
  ElementMismatch = 'ELEMENT_MISMATCH',
  DoubleCheck = 'DOUBLE_CHECK',
  LeaveDown = 'LEAVE_DOWN',
  Obsolete = 'OBSOLETE',
  ExternalSystemSpotlightType = 'EXTERNAL_SYSTEM_SPOTLIGHT_TYPE',
  HealthAndSafety = 'HEALTH_AND_SAFETY'
}

export type StringUpdate = {
  newValue: Scalars['String'];
};

export type Subcontractor = {
  __typename?: 'Subcontractor';
  id: Scalars['UUID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  spaces?: Maybe<Array<Space>>;
};

export type SubcontractorBatchProgress = {
  __typename?: 'SubcontractorBatchProgress';
  batchId: Scalars['UUID'];
  actualProgress?: Maybe<Scalars['Float']>;
  plannedProgress?: Maybe<Scalars['Float']>;
};

export type SubcontractorPlannedDates = {
  __typename?: 'SubcontractorPlannedDates';
  spaceId: Scalars['UUID'];
  subcontractorId: Scalars['UUID'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type SubcontractorPlannedDatesInSpaces = {
  __typename?: 'SubcontractorPlannedDatesInSpaces';
  subcontractorId: Scalars['UUID'];
  subcontractorName: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type SubcontractorPlannedDatesInput = {
  spaceId: Scalars['UUID'];
  subcontractorId: Scalars['UUID'];
};

export type SubcontractorSpaceMapping = {
  subcontractorId: Scalars['UUID'];
  spaceIds: Array<Scalars['UUID']>;
};

export type SyncOpenSpaceSheetDataResult = {
  __typename?: 'SyncOpenSpaceSheetDataResult';
  projectsProcessed: Scalars['Int'];
  updatedMappings: Scalars['Int'];
};

export type Task = {
  __typename?: 'Task';
  id: Scalars['UUID'];
  shell360Id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  guiIndex: Scalars['Int'];
  parentTask?: Maybe<Task>;
  childTasks: Array<Task>;
  descendantTasks: Array<Task>;
  childComponents: Array<Component>;
  plan: Plan;
  isMapped: Scalars['Boolean'];
  ancestors: Array<Task>;
  aggregatedProgresses: Array<AggregatedProgress>;
  aggregatedPlannedProgresses: Array<AggregatedPlannedProgress>;
  arbitraryAggregatedProgresses: Array<AggregatedArbitraryProgress>;
  arbitraryAggregatedPlannedProgresses: Array<AggregatedArbitraryPlannedProgress>;
  actualDates: Array<Dates>;
};


export type TaskAncestorsArgs = {
  includeSelf?: Scalars['Boolean'];
};


export type TaskAggregatedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  batchIds: Array<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  onlyInProgressTasks?: Maybe<Scalars['Boolean']>;
};


export type TaskAggregatedPlannedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  timestamps: Array<Scalars['Date']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
};


export type TaskArbitraryAggregatedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  componentIds?: Maybe<Array<Scalars['UUID']>>;
  batchIds: Array<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  forPva?: Maybe<Scalars['Boolean']>;
};


export type TaskArbitraryAggregatedPlannedProgressesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  componentIds?: Maybe<Array<Scalars['UUID']>>;
  timestamps: Array<Scalars['Date']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  subcontractorIds?: Maybe<Array<Scalars['UUID']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
  forceSlowAggs?: Maybe<Scalars['Boolean']>;
  forPva?: Maybe<Scalars['Boolean']>;
};


export type TaskActualDatesArgs = {
  spaceIds: Array<Scalars['UUID']>;
  spaceTags?: Maybe<Array<Scalars['String']>>;
  spaceGroupingTags?: Maybe<Array<Scalars['String']>>;
  componentTags?: Maybe<Array<Scalars['String']>>;
  excludeHoistSpaces?: Maybe<Scalars['Boolean']>;
};

export type TaskSchedule = {
  __typename?: 'TaskSchedule';
  task: Task;
  space: Scalars['UUID'];
  subcontractor: Scalars['UUID'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type TaskScheduleInSpaces = {
  __typename?: 'TaskScheduleInSpaces';
  task: Task;
  subcontractor: Scalars['UUID'];
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type TenantInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  scope: Scope;
};


export type UuidUpdate = {
  newValue: Scalars['UUID'];
};

export type UpdateArrowInputType = {
  id: Scalars['UUID'];
  sceneId: Scalars['UUID'];
  targetSceneId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  location: AnnotationLocationInputType;
};

export type UpdateBatchInputType = {
  id: Scalars['UUID'];
  timestamp: Scalars['Date'];
  weekNumber: Scalars['Int'];
};

export type UpdateComponentInputType = {
  id: Scalars['UUID'];
  taskId?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  componentTypeId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  weight?: Maybe<Scalars['Float']>;
  guiIndex?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type UpdateCustomerInputType = {
  customer: Scalars['String'];
  collabStarted?: Maybe<Scalars['Date']>;
  imagesCaptured?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  upcomingProjects?: Maybe<Scalars['Int']>;
};

export type UpdateEndDateInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
};

export type UpdateIsCompletedProjectConfigInput = {
  customer: Scalars['String'];
  project: Scalars['String'];
  isCompleted: Scalars['Boolean'];
};

export type UpdateIsReleasedProjectConfigInput = {
  customer: Scalars['String'];
  project: Scalars['String'];
  isReleased: Scalars['Boolean'];
};

export type UpdateIsTicksheetProjectConfigInput = {
  customer: Scalars['String'];
  project: Scalars['String'];
  isTicksheetProject: Scalars['Boolean'];
};

export type UpdateIsTrackingProjectConfigInput = {
  customer: Scalars['String'];
  project: Scalars['String'];
  isTracking: Scalars['Boolean'];
};

export type UpdateMappingInputType = {
  id: Scalars['UUID'];
  disabled: Scalars['Boolean'];
};

export type UpdateProjectDisplayNameInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
};

export type UpdateProjectDivisionInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  division?: Maybe<Scalars['String']>;
};

export type UpdateProjectOpenSpaceSiteMappingInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  organization?: Maybe<Scalars['String']>;
  sites?: Maybe<Array<Scalars['String']>>;
  region?: Maybe<Scalars['String']>;
};

export type UpdateProjectWorkingDaysInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  workingDays?: Maybe<Array<Scalars['Int']>>;
};

export type UpdateReceivedOnInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  receivedOn?: Maybe<Scalars['Date']>;
};

export type UpdateScanSequenceInputType = {
  id: Scalars['UUID'];
  floorplanId: Scalars['UUID'];
  sequencePrefix: ScanSequencePrefixType;
  scanLevel: ScanSequenceLevelType;
  sceneIds: Array<Scalars['UUID']>;
};

export type UpdateSceneInputType = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  guiIndex: Scalars['Int'];
  spaceId: Scalars['UUID'];
  mmX?: Maybe<Scalars['Float']>;
  mmY?: Maybe<Scalars['Float']>;
  mmZOffset?: Maybe<Scalars['Float']>;
};

export type UpdateSpaceInputType = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  guiIndex: Scalars['Int'];
  category?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UpdateSpotlightInputType = {
  id: Scalars['UUID'];
  batchId?: Maybe<Scalars['UUID']>;
  type?: Maybe<SpotlightType>;
  mappingId?: Maybe<Scalars['UUID']>;
  subcontractorId?: Maybe<Scalars['UUID']>;
  location?: Maybe<AnnotationLocationInputType>;
  sceneId?: Maybe<Scalars['UUID']>;
  createdInBatchId?: Maybe<Scalars['UUID']>;
  resolvedInBatchId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  p2Type?: Maybe<P2SpotlightType>;
  defaultPriority?: Maybe<SpotlightPriority>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<SpotlightStatus>;
  priority?: Maybe<SpotlightPriority>;
};

export type UpdateStartDateInputType = {
  customer: Scalars['String'];
  project: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
};

export type UpdateSubcontractorInputType = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  displayName: Scalars['String'];
};

export type UpdateTaskInputType = {
  id: Scalars['UUID'];
  name: Scalars['String'];
  guiIndex: Scalars['Int'];
  planId: Scalars['UUID'];
  parentTaskId?: Maybe<Scalars['UUID']>;
};


export type User = {
  __typename?: 'User';
  username: Scalars['String'];
};

export type SceneBatchSpotlightIds = {
  sceneId: Scalars['UUID'];
  batchId: Scalars['UUID'];
  spotlightId: Scalars['UUID'];
};
